import { createFeatureSelector } from '@ngrx/store';
import { PaymentStatusModel } from '../reducers/paymentStatus';

export const selectPaymentState = createFeatureSelector<PaymentStatusModel>(
  'paymentStatus'
);
